import cn from 'classnames';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Button } from 'src/components/common/Button';
import { useConnectedAction } from 'src/hooks/use-connected-action';
import { openAuthModal } from 'src/store/auth-modal/actions';
import { RootState } from 'src/types/store-types';
import BuyNowDialog from '../BuyNowDialog';
import './styles.scss';

type IProps = {
  classname?: string;
};

const SafesShop: FC<IProps> = ({ classname }) => {
  const { t }: Translation = useTranslation();

  const _openAuthModal = useConnectedAction(openAuthModal);

  const user = useSelector((state: RootState) => state.user?.user);

  // States
  const [isOpenBuyNowDialog, setIsOpenBuyNowDialog] = React.useState<boolean>(false);

  const onBuySafeHandler = (): void => {
    if (user) {
      setIsOpenBuyNowDialog(true);
    } else {
      _openAuthModal('login');
    }
  };

  return (
    <>
      <div className={cn('safes_shop', classname)}>
        <div className="safes_shop_content">
          <div className="safes_shop_images_container">
            <div className="safes_shop_image_block">
              <img src="/images/safePromo/safe1.png" alt="safe 1" className="afes_shop_image" />
              <div className="safes_shop_buy_value">
                <span>+1</span>
              </div>
            </div>
            <div className="safes_shop_image_block">
              <img src="/images/safePromo/safe2.png" alt="safe 2" className="afes_shop_image" />
              <div className="safes_shop_buy_value">
                <span>+1</span>
              </div>
            </div>
            <div className="safes_shop_image_block">
              <img src="/images/safePromo/safe3.png" alt="safe 3" className="afes_shop_image" />
              <div className="safes_shop_buy_value">
                <span>+1</span>
              </div>
            </div>
          </div>
          <Button size="md" className="primary-filled-btn" onClick={onBuySafeHandler}>
            {t('safe_promo.safesShopBuyNowButton')}
          </Button>
        </div>
      </div>
      <BuyNowDialog isOpen={isOpenBuyNowDialog} onClose={() => setIsOpenBuyNowDialog(false)} />
    </>
  );
};
export default SafesShop;
